import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { eventsModule, eventsModuleName } from './modules/events/store/index';
import { playersModule, playersModuleName } from './modules/players/store/index';
import { teamsModule, teamsModuleName } from './modules/teams/store/index';
import { scheduleModule, scheduleModuleName } from './modules/schedule/store';
import { leagueModule, leagueModuleName } from './modules/league/store';
import { commentsModule, commentsModuleName } from './modules/comments/store';
import { usersModule, usersModuleName } from './modules/users/store';
import { sitesModule, sitesModuleName } from './modules/sites/store';

// tslint:disable-next-line:no-empty-interface
export interface RootState {}

Vue.use(Vuex);

const storeOptions: StoreOptions<RootState> = {
  state: {},
  modules: {
    [scheduleModuleName]: scheduleModule,
    [eventsModuleName]: eventsModule,
    [playersModuleName]: playersModule,
    [teamsModuleName]: teamsModule,
    [leagueModuleName]: leagueModule,
    [commentsModuleName]: commentsModule,
    [usersModuleName]: usersModule,
    [sitesModuleName]: sitesModule,

  },
};

export const store = new Vuex.Store<RootState>(storeOptions);
